<!-- single level menu (flat section — e.g. GLOBAL Modules/Roles/Features) -->
@if (!section.hasSectionItems) {
  <mat-nav-list class="p-0">
    <app-menu-section-item [item]="section"></app-menu-section-item>
  </mat-nav-list>
} @else {
  <!-- multiple level menu: cascading expansion panel, matching the GLOBAL menu
       (no leading icon, standard chevron toggle, panel-body indentation). -->
  <mat-expansion-panel [expanded]="section.selected"
                       (expandedChange)="section.selected = $event"
                       class="menu-section-expansion-panel mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="sidenav-heading">{{ section.label }}</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-nav-list class="p-0">
      @for (item of section.sectionItems; track item) {
        <app-menu-section-item [item]="item"></app-menu-section-item>
      }
    </mat-nav-list>
  </mat-expansion-panel>
}
